import type { SearchSuggestion } from './types'

type Props = {
  inputId: string
  suggestionsOpen: boolean
  liveLoading: boolean
  suggestions: SearchSuggestion[]
  activeIndex: number
  trimmedQuery: string
  onHoverIndex: (index: number) => void
  onNavigateToSuggestion: (suggestion: SearchSuggestion) => void
}

const SearchSuggestionsDropdown = ({
  inputId,
  suggestionsOpen,
  liveLoading,
  suggestions,
  activeIndex,
  trimmedQuery,
  onHoverIndex,
  onNavigateToSuggestion,
}: Props) => {
  if (!suggestionsOpen || trimmedQuery.length < 2) return null

  return (
    <div
      id={`${inputId}-results`}
      className="absolute left-0 right-0 top-[calc(100%+0.4rem)] z-50 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-xl"
      role="listbox"
      aria-label="Suggerimenti ricerca"
    >
      {liveLoading && <p className="px-3 py-2 text-sm text-slate-500">Ricerca in corso...</p>}
      {!liveLoading && suggestions.length === 0 && (
        <p className="px-3 py-2 text-sm text-slate-500">Nessun prodotto trovato</p>
      )}
      {!liveLoading && suggestions.length > 0 && (
        <ul className="max-h-[360px] overflow-y-auto">
          {suggestions.map((item, index) => (
            <li
              key={`${item.slug}-${index}`}
              id={`${inputId}-item-${index}`}
              role="option"
              aria-selected={activeIndex === index}
            >
              <button
                type="button"
                className={`flex w-full items-center gap-3 px-3 py-2 text-left transition ${
                  activeIndex === index ? 'bg-cyan-50' : 'hover:bg-slate-50'
                }`}
                onMouseDown={(event) => {
                  event.preventDefault()
                }}
                onMouseEnter={() => onHoverIndex(index)}
                onClick={() => onNavigateToSuggestion(item)}
              >
                {item.imageUrl ? (
                  <img
                    src={item.imageUrl}
                    alt={item.name}
                    className="h-10 w-10 rounded-md border border-slate-200 bg-slate-50 object-cover"
                    loading="lazy"
                  />
                ) : (
                  <span className="grid h-10 w-10 place-items-center rounded-md border border-slate-200 bg-slate-50 text-[10px] font-bold uppercase tracking-[0.12em] text-slate-500">
                    {item.name.slice(0, 2).toUpperCase()}
                  </span>
                )}
                <span className="min-w-0 flex-1">
                  <span className="block truncate text-sm font-semibold text-slate-900">{item.name}</span>
                  <span className="block truncate text-xs text-slate-500">
                    {item.publicCode ? `/dp/${item.publicCode}` : `/${item.slug}`}
                  </span>
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default SearchSuggestionsDropdown
